/**
 * Humanizes a resource code: `VIRTUAL_INTERCOM_MANAGEMENT_VIDEO` -> `Virtual Intercom Management Video`.
 */
export function humanizeResource(resource: string): string {
  return resource
    .split('_')
    .filter(part => part.length > 0)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Normalizes free text typed by the user into an UPPER_SNAKE_CASE resource code.
 */
export function normalizeResourceCode(input: string): string {
  return input
    .trim()
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase();
}
